<i18n src="../../../lib/i18n/product/locales.json"></i18n>
<template>
    <Row>
        <navbar></navbar>
        <div class="detail_slide_m1" ref="mybox">
            <div class="zengo max_width">
                <h1 class="banner-title">ZENGÕ M1</h1>
                <p class="Store-banner-sm-title">{{$t('m1_details_page_banner_title')}}</p>
                <p class="banner-content" style="padding-bottom: 10px;">{{$t('m1_details_page_banner_sm_title')}}</p>
                <img class="zengo-m1-img" src="../../../assets/store/m1/zengo-m1.png" width="200" style="margin-top: 3%;">
            </div>

        </div>
        <div class="layout-content " style="z-index: 1;margin: 0 auto;">
            <div class="Product-content mogos">
                <div class="Product-content max_width" style="background: #FFFFFF;padding:6% 0 6% 0;">
                    <Row style="padding:0 3% 0 3%">
                        <Col class="Product-left"  :md="13" style="text-align: center;">
                            <img src="../../../assets/store/m1/zengom1_2.png" class="mogos-logo">
                        </Col>
                        <Col class="Product-right" :md="11" style="text-align: left;">
                        <p class="Product-name">
                            {{$t('m1_details_page_product_title')}}
                        </p>
                        <p class="Product-price">
                            ${{goods_info.goods_price}}
                        </p>
                        <p class="Product-details">
                          {{$t('m1_details_page_product_content')}}
                        </p>
                        <ul>
                            <li class="Product-details-li">{{$t('m1_details_page_product_content1')}}</li>
                            <li class="Product-details-li">{{$t('m1_details_page_product_content2')}}</li>
                            <li class="Product-details-li">{{$t('m1_details_page_product_content3')}}</li>
                        </ul>
                        <buy :id="parseInt($route.query.id)" :maxCount="parseInt(goods_info.store_count)"></buy>
                        </Col>
                    </Row>
                </div>

                <div class="Product-content">
                    <Row>
                        <i-col class="Product-right" span="24" style="text-align: center;padding:5% 0;">
                            <p class="idual-title">
                                {{$t('m1_details_page_advantage1')}}
                            </p>
                            <p class="idual-text">
                                {{$t('m1_details_page_advantage1_content')}}
                            </p>
                            <div class="igo-product-details-page" style="background: #FFFFFF;margin-top: 2%;">
                                <img class="cable-img-1" src="../../../assets/store/m1/zengom1_bg_2.png" />
                            </div>
                            <div class="idual-i"  style="margin: 40px 0;">
                                <Row>
                                    <i-col :xs="2" :sm="4" :md="6" :lg="8" style="color:transparent">c</i-col>
                                    <i-col :span="24" class="m1-v">
                                        <ul>
                                            <li>
                                                <img src="../../../assets/store/m1/icon2.png">
                                                <p>{{$t('m1_details_page_features1')}}</p>
                                            </li>
                                            <li>
                                                <img src="../../../assets/store/m1/icon3.png">
                                                <p>{{$t('m1_details_page_features2')}}</p>
                                            </li>
                                            <li>
                                                <img src="../../../assets/store/m1/icon4.png">
                                                <p>{{$t('m1_details_page_features3')}}</p>
                                            </li>
                                            <li>
                                                <img src="../../../assets/store/m1/icon5.png">
                                                <p>{{$t('m1_details_page_features4')}}</p>
                                            </li>
                                            <li>
                                                <img src="../../../assets/store/m1/icon6.png">
                                                <p>{{$t('m1_details_page_features5')}}</p>
                                            </li>
                                        </ul>
                                    </i-col>
                                    <i-col :xs="2" :sm="4" :md="6" :lg="8" style="color:transparent">c</i-col>
                                </Row>
                            </div>
                        </i-col>
                        <i-col class="Product-right" span="24" style="text-align: center;padding:5% 0;">
                            <p class="idual-title">
                                {{$t('m1_details_page_advantage2')}}
                            </p>
                            <p class="idual-text">
                                {{$t('m1_details_page_advantage2_content')}}
                            </p>
                            <div class="idual-i"  style="margin: 50px 0;">
                                <Row class="m1-v3">
                                    <i-col :md="6" :sm="12" :xs="12">
                                        <img src="../../../assets/store/m1/icon7.png" width="80%">
                                    </i-col>
                                    <i-col :md="6" :sm="12" :xs="12">
                                        <img src="../../../assets/store/m1/icon8.png" width="80%">
                                    </i-col>
                                    <i-col :md="6" :sm="12" :xs="12">
                                        <img src="../../../assets/store/m1/icon9.png" width="80%">
                                    </i-col>
                                    <i-col :md="6" :sm="12" :xs="12">
                                        <img src="../../../assets/store/m1/icon10.png" width="80%">
                                    </i-col>
                                </Row>
                            </div>
                        </i-col>
                    </Row>
                </div>
                <div class="Product-content">
                    <div class="Product-content" style="background-image: linear-gradient(120deg, #FFFFFF 0%, #FDFDFD 30%,#E7E8E9 100%);padding:3% 0 0 0;">
                        <p class="idual-title">
                            {{$t('m1_details_page_advantage3')}}
                        </p>
                        <p class="idual-text">
                            {{$t('m1_details_page_advantage3_content')}}
                        </p>
                        <div class="Product-content-img">
                            <img src="../../../assets/store/m1/zengom1_4.png" width="100%">
                        </div>
                    </div>
                </div>
                <div class="Product-content max_width">
                    <div class="Product-content" style="padding:3% 0 0 0;">
                        <p class="idual-title">
                            {{$t('m1_details_page_advantage4')}}
                        </p>
                        <p class="idual-text">
                            {{$t('m1_details_page_advantage4_content')}}
                        </p>
                        <div class="Product-content-img-1">
                            <img src="../../../assets/store/m1/zengom1_5.png" width="100%">
                        </div>
                    </div>
                    <div class="Product-content max_width" style="padding:3% 0 0 0;">
                        <p class="idual-title">
                            {{$t('m1_details_page_advantage5')}}
                        </p>
                        <p class="idual-text">
                            {{$t('m1_details_page_advantage5_content')}}
                        </p>
                        <div class="Product-content-img-2">
                            <img src="../../../assets/store/m1/zengom1_bg_3.png" width="100%">
                        </div>
                    </div>
                </div>
                <div class="Product-content">
                    <div class="Product-content" style="background-image: linear-gradient(120deg, #FFFFFF 0%, #FDFDFD 30%,#E7E8E9 100%);padding:10% 0 10% 0;">
                        <Row style="max-width:820px;margin: 0 auto;">
                            <Col class="Product-right" :md="12">
                            <div class="Product-right-main">
                                <ul class="Parameter">
                                    <li>{{$t('details_page_product_parameters')}}</li>
                                    <li>{{$t('m1_details_page_product_parameters1')}}</li>
                                    <li>{{$t('m1_details_page_product_parameters2')}}</li>
                                    <li>{{$t('m1_details_page_product_parameters3')}}</li>
                                    <li>{{$t('m1_details_page_product_parameters4')}}</li>
                                    <li>{{$t('m1_details_page_product_parameters5')}}</li>
                                    <li>{{$t('m1_details_page_product_parameters6')}}</li>
                                    <li>{{$t('m1_details_page_product_parameters7')}}</li>
                                    <li>{{$t('m1_details_page_product_parameters8')}}</li>
                                </ul>
                            </div>
                            </Col>
                            <Col class="Product-left"  :md="12" style="text-align: center;">
                            <img src="../../../assets/store/m1/zengom1_3.png" class="m1-img" width="100%">
                            </Col>
                        </Row>
                    </div>
                </div>
                <div class="detail-basis max_width" style="max-width: 1200px;margin: 0 auto;">
                    <ul>
                        <li>{{$t('shopping_notes')}}</li>
                        <li>
                            {{$t('shopping_notes_tip')}}
                        </li>
                    </ul>
                    <guess></guess>
                </div>
            </div>
        </div>
    </Row>
</template>
<script>
    import navbar from '../../Common/Navbar.vue'
    import guess from '../../Profiler/Common/Guess.vue'
    import buy from '../../Common/Buy.vue'
    import Signature from '../../../lib/Signature'

    export default {
        data () {
            return {
                value1: 0,
                minus_text: 1,
                scroll: '',
                active: false,
                num: 1,
                goods_info: {}

            }
        },
        components: {
            navbar,
            guess,
            buy
        },
        created () {
            let module = 'index.php/index/goods/goodsinfo'
            let data = {}
            data.sub_time = Signature.timestamp()
            data.sign = Signature.create(module, data.sub_time)
            data.user_id = this.Local.getUserId()
            data.token = this.Local.getUserToken()
            data.lang = this.$i18n.locale
            data.goods_id = this.$route.params.id || this.$route.query.id
            this.$http.get(process.env.BASEURL + module, {
                params: data
            }).then(function (resp) {
                if (parseInt(resp.data.code) === 2000) {
                    this.goods_info = resp.data.data.goods_info
                }
            }.bind(this))
        },
        mounted () {
            window.addEventListener('scroll', this.init)
        },
        methods: {
            minus: function () {
                if (this.minus_text > 1) {
                    this.minus_text--
                }
            },
            add: function () {
                if (this.minus_text < 99) {
                    this.minus_text++
                }
            },
            tab (index) {
                this.num = index
            }
        }

    }
</script>
<style scoped>

    .detail_slide_m1 {
        height: 100vh;
        max-height: 760px;
        background: url("../../../assets/store/zengo-mifi.jpg") no-repeat center;
        background-size: cover;
        position: relative;
        overflow: hidden;
    }
    .zengo{
        width: 100%;
        margin: 0 auto;
        text-align: left;
        color: white;
    }
    .max_width{
        max-width: 1200px;
    }

    .banner-title,.Store-banner-sm-title{
        font-weight: 500;
        font-size: 32px;
    }
    .Product-more{
        font-size: 18px;
    }
    .banner-content{
        padding:1% 0 0% 0;
    }
    .details_banner_text {
        font-size: 32px;
        color: #fff;
        letter-spacing: 0;
        line-height: 78px;
    }
    .details_banner_text2 {
        font-size: 22px;
        color: #fff;
        letter-spacing: 0;
        line-height: 32px;
    }
    .mogos {
        position: relative;
    }
    .Product-name {
        font-size: 32px;
        color: #1F2D3D;
        line-height: 56px;
    }
    .Product-price {
        font-size: 32px;
        color: #0084ff;
        line-height: 26px;
        margin: 3% 0 3% 0;
    }
    .Product-right-main{
        width: 70%;
        margin: 0 auto;
        text-align: left;
    }
    .Product-details {
        font-size: 16px;
        color: #5E6D82;
        letter-spacing: 0;
        line-height: 22px;
        padding: 0 20% 5% 0;
    }
    .Product-details-li{
        font-size: 16px;
        color: #5E6D82;
    }
    .Product-content-img{
        width: 100%;
        max-width: 300px;
        min-width: 170px;
        margin: 0 auto;
        padding: 7% 0 5% 0;
    }
    .Product-content-img-1{
        width: 100%;
        max-width: 700px;
        min-width: 270px;
        margin: 0 auto;
        padding: 7% 0 5% 0;
    }
    .Product-content-img-2{
        width: 100%;
        max-width: 1300px;
        min-width:290px;
        margin: 0 auto;
        padding: 7% 0 5% 0;
    }
    .Product-btn {
        border: 1px solid #0084FF;
        border-radius: 5px;
        height: 50px;
        width: 200px;
        font-size: 20px;
        color: #0084FF;
        background: transparent;
        margin: 5% 6% 0% 0%;
    }
    .Product-btn:hover {
        background: #0084FF;
        color: white;
    }
    .details_card_text div {
        font-size: 16px;
        letter-spacing: 0;
        line-height: 24px;
        border-radius: 0px !important;
        padding: 15px 0;
    }
    .swiper-pagination span p {
        width: 300px;
        text-align: left;
        line-height: 24px;
    }
    .swiper-pagination span p span {
        margin: 0 40px 0 5px;
        color: #fff;
        font-size: 14px;
    }
    .idual-title{
        font-size: 22px;
        color: #1F2D3D;
        letter-spacing: 0;
        line-height: 40px;
        padding: 0 10% 15px 10%;
    }
    .idual-text{
        font-size: 16px;
        color: #1F2D3D;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 24px;
        width: 60%;
        margin: 0 auto;
        padding: 0 10%;
    }
    .m1-v ul li{
        display: inline-block;
        padding: 0 2% 0 2%;
    }
    .m1-v3{
        width: 60%;
        margin: 0 auto;
    }
    .battery-img{
        margin:0 20px;
    }
    .idual-nano{
        position: absolute;right: 20%;text-align: left;margin-top: 60px;
    }
    .idual-nano li:first-child{
        font-family: PingFangSC-Semibold;
        font-size: 22px;
        color: #1F2D3D;
        letter-spacing: 0;
        line-height: 40px;
    }
    .idual-nano li{
        font-size: 16px;
        color: #5E6D82;
        letter-spacing: 0;
        line-height: 24px;
    }
    .details_tip{
        font-family: PingFangSC-Semibold;
        font-size: 22px;
        color: #1F2D3D;
        letter-spacing: 0;
        line-height: 40px;
    }
    .details_tip2{
        font-size: 16px;
        color: #5E6D82;
        letter-spacing: 0;
        line-height: 24px;
    }
    .detail-basis ul{
        width:100%;
        max-width: 1200px;
        margin: 0 auto !important;
        padding: 30px 10px;
    }
    .detail-basis ul li{
        font-size: 16px;
        color: #000000;
        letter-spacing: 0;
        line-height: 24px;
        text-align: left;
    }
    .detail-basis ul li:first-child{
        color: #0084FF;
    }
    .cable-img-1{
        width:50%
    }
    /*滚动条*/
    ::-webkit-scrollbar {
        width: 0px;
    }
    .Parameter li{
        font-size: 16px;
        color: #1F2D3D;
        letter-spacing: 0;
        line-height: 24px;
    }
    .Parameter li:first-child{
        font-size: 20px;
        margin-bottom: 20px;
        line-height: 40px;
    }


    @media screen and (max-width: 992px) {
        .Product-left, .Product-right {  text-align: center !important;  }
        .idual-nano{  position: relative;  text-align: center;  margin-top: 20px;  right: 0;  }
        .idual-nano li:first-child{ font-size:16px; }
        .idual-nano li{ font-size: 12px; }
    }

    @media screen and (max-width: 768px) {
        .detail_slide_m1{
            background-position: 85% 60px;
        }
        .Product-details{  padding: 0 0 20px 0;  text-align: left}
        .mogos-logo{  width:80%;  }
        .details_banner_text{  font-size: 45px;  line-height: 55px;  padding: 0 5%;  }
        .details_banner_text2{  margin:50px 0;  font-size:24px;  line-height: 25px;  }
        .Product-btn{  margin:5% 0 0 0;  }
        .idual-img{  width:100%;  margin:100px 0 0 0px;  }
        .idual-i img{  width: 80%;  }
        .idual-nano li:first-child{ font-size:16px; }
        .idual-nano li{ font-size: 12px; }
        .detail_slide_1{
            background: url("../../../assets/store/igo-mifi_mobile.png") no-repeat;
            background-size: cover;
        }
        .m1-img{
            margin-top: 20px;
        }
    }
    @media screen and (max-width: 500px){
        .details_banner_text{  font-size: 21px;  line-height: 35px;  padding: 0 5%;  }
        .details_banner_text2{  font-size:14px;  margin:15px 0;  line-height: 20px;  }
        .Product-name{ font-size:24px; }
        .Product-details{font-size:14px;padding: 10px 20px; }
        .Product-price{ font-size:30px; }
        .Parameter li{  font-size:16px;  line-height: 30px;  text-align: left;  }
        .idual-img{  display: none;  }
        .idual-i img{  width: 80%;  }
        .battery-img img{  width:80%;  }
        .battery-imgs img{width:60%;}
        .cable-img-1{  width:90%  }
        .battery-img{  margin:0 10px;  }
        .idual-title{  font-size: 20px;  }
        .idual-text{  font-size: 14px;}
        .detail_slide_m1 {  background-position: 80% 50px;}
        .Product-details-li{
            font-size: 14px;
        }
        .detail_slide_m1{
            background: url("../../../assets/home/new_home/zengo-m1-1@2x.jpg") center no-repeat;
        }
        .Product-right-main{
            padding: 0 30px;
        }
        .m1-img{
            width: 80%;
        }
    }
    @media (min-width: 1000px) and (max-width: 1024px){
        .Product-details{  padding: 0px 0% 2% 0px;  }
        .idual-img{  width:100%;  margin:100px 0 0 100px;  }
    }
    @media (max-width: 414px) {
        .detail_slide_1{
            height: 700px;
        }
        .zengo{
            padding-left: 20px;
        }
        .Product-right-main{
            width: 100%;
        }
        .idual-title{
            font-weight: 26px;
        }
        .idual-text{
            width: 100%;
        }
        .zengo-m1-img{
            display: none;
        }
        .banner-title{
            margin-top:15%;
            line-height: 24px;
        }
        .banner-title,.Store-banner-sm-title{
            font-size: 24px;
        }
        .banner-content{
            font-size: 16px;
        }
        .Product-more{
            font-size: 16px;
        }
    }
    @media (max-width: 375px) {
        .detail_slide_1{
            height: 650px;
        }
    }
    @media (max-width: 320px) {
        .detail_slide_1{
            height: 550px;
        }
        .banner-title,.Store-banner-sm-title{
            font-size: 24px;
        }
    }
</style>



// WEBPACK FOOTER //
// M1.vue?0824a18b